import { render, staticRenderFns } from "./FixedSideMenu.vue?vue&type=template&id=e5622c5c&scoped=true&"
import script from "./FixedSideMenu.vue?vue&type=script&lang=ts&"
export * from "./FixedSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FixedSideMenu.vue?vue&type=style&index=0&id=e5622c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5622c5c",
  null
  
)

export default component.exports